// extracted by mini-css-extract-plugin
export var bar = "BookingSearchBox-module--bar--29HZg";
export var packages = "BookingSearchBox-module--packages--nBGFB";
export var placeholder = "BookingSearchBox-module--placeholder--3nl6v";
export var flights = "BookingSearchBox-module--flights--2koj3";
export var hotels = "BookingSearchBox-module--hotels--1d6hH";
export var cruises = "BookingSearchBox-module--cruises--2FVuN";